import axios, {AxiosInstance} from 'axios';
import StorageUtils from '@spothero/utils/storage';
import Config from 'hooks/config';

const additionalHeaders: Record<string, string> = {
    UserAgent: 'spothero-control-panel',
    'X-CSRFToken': StorageUtils.get('csrftoken', 'cookie') || '',
};

/**
 * Creates an axios instance of the monolith api service
 */
export const monolithAPIService: AxiosInstance = axios.create({
    baseURL: Config.spotHeroAPIPath,
    headers: {
        ...additionalHeaders,
    },
});

/**
 * Creates an axios instance of the monolith api service v2
 */
export const monolithAPIServiceV2: AxiosInstance = axios.create({
    baseURL: Config.spotHeroAPIPathV2,
    headers: {
        ...additionalHeaders,
    },
});

/**
 * Creates an axios instance of the authentication API service.
 */
export const authAPIService: AxiosInstance = axios.create({
    baseURL: Config.authAPIUrl,
    withCredentials: false,
});

/**
 * Creates an axios instance for the control panel service
 */
export const cpAPIService: AxiosInstance = axios.create({
    baseURL: Config.cpAPIUrl,
    headers: {
        ...additionalHeaders,
    },
});

/**
 * Creates an axios instance for the control panel service v2
 */
export const cpAPIServiceV2: AxiosInstance = axios.create({
    baseURL: Config.cpAPIUrlV2,
    headers: {
        ...additionalHeaders,
    },
});

/**
 * Creates an axios instance for the Postman Operator mock API server
 */
export const mockOperatorAPIService: AxiosInstance = axios.create({
    baseURL: 'https://0f81049e-e740-4a24-900e-b10ed30de72f.mock.pstmn.io/v1/',
    headers: {
        ...additionalHeaders,
    },
});
